module.exports = __webpack_public_path__ + "img/CN-注册2.64ae310f.png";